export default __webpack_public_path__ + "static/media/18-BB-(2-2).f06bfa40.jpg";